/** Picks which recovery-phrase words the user must type back when creating a vault. */
/** Three different word positions (1-based) to confirm the written-down phrase. */
export function pickCheckPositions(wordCount: number, random: () => number = Math.random): number[] {
  const picked = new Set<number>();
  while (picked.size < 3) picked.add(1 + Math.floor(random() * wordCount));
  return [...picked].sort((a, b) => a - b);
}
